import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { KeyRound } from "lucide-react";

export function PasswordResetCard() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const sendReset = async () => {
    if (!email) return;
    setLoading(true);
    try {
      const redirectTo = `${window.location.origin}/auth/callback`;
      const { data, error } = await supabase.functions.invoke('admin-send-password-reset', {
        body: { email, redirectTo },
      });

      if (error) throw error;

      toast({
        title: "Reset email sent",
        description: `Password reset email sent to ${email}`,
      });
      setEmail("");
    } catch (e: any) {
      toast({
        title: "Error",
        description: e?.message || 'Failed to send reset email',
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <KeyRound className="w-5 h-5" />
          Send Password Reset
        </CardTitle>
        <CardDescription>Send a password reset email to any user</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex gap-4">
          <Input
            type="email"
            placeholder="user@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex-1"
          />
          <Button onClick={sendReset} disabled={!email || loading}>
            Send Reset
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
